"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyPricingPaymentMethods = exports.makeEmptyQuotaConfiguration = void 0;
exports.makeEmptyQuotaConfiguration = function () { return ({
    max: 0,
    min: 0,
    type: '',
}); };
exports.makeEmptyPricingPaymentMethods = function () { return ({
    coreCode: '',
    description: '',
    id: 0,
    quotaConfiguration: exports.makeEmptyQuotaConfiguration(),
    renderConditions: null,
}); };
//# sourceMappingURL=PricingPaymentMethods.js.map